import { createApi } from '@reduxjs/toolkit/query/react';

import { createGraphQLFetchBaseQuery } from '@/shared/redux/api/utils/graphql-fetch-base-query';

export const API_URL = import.meta.env.VITE_APP_SDA_API_URL;

export const API_URLS = {
  BACKOFFICE: `${API_URL}/backoffice/graphql/v1`,
  BILLING_BACKOFFICE: `${API_URL}/billing-backoffice/graphql/v1`,
  IDEAAS_BACKOFFICE: `${API_URL}/ideaas-backoffice/graphql/v1`,
} as const;

export const LEGACY_API_URLS = {
  BACKOFFICE: `${API_URL}/backoffice/v1/graphql`,
  BILLING_BACKOFFICE: `${API_URL}/billing-backoffice/v1/graphql`,
} as const;

// Factory functions for creating APIs
const createBaseApi = (
  url: string,
  fallbackUrl: string | undefined,
  reducerPath: string,
) =>
  createApi({
    baseQuery: createGraphQLFetchBaseQuery(url, fallbackUrl, true, false),
    endpoints: () => ({}),
    reducerPath,
  });

// API instances
export const baseBackofficeApi = createBaseApi(
  API_URLS.BACKOFFICE,
  LEGACY_API_URLS.BACKOFFICE,
  'backoffice',
);
export const baseBillingBackofficeApi = createBaseApi(
  API_URLS.BILLING_BACKOFFICE,
  LEGACY_API_URLS.BILLING_BACKOFFICE,
  'billing-backoffice',
);
// A separate, parallel stack (not a URL-shape fallback of the main backoffice
// API), so no fallbackUrl.
export const baseIdeaasBackofficeApi = createBaseApi(
  API_URLS.IDEAAS_BACKOFFICE,
  undefined,
  'ideaasBackoffice',
);
